import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Slide,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { forwardRef } from 'react'
import Button from './Button'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const Modal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  fullWidth = true,
  showCloseButton = true,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') return
    if (disableEscapeKeyDown && reason === 'escapeKeyDown') return
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={isMobile}
      TransitionComponent={isMobile ? Transition : undefined}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          m: isMobile ? 0 : 2,
        },
      }}
    >
      {title && (
        <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" component="span" fontWeight={600}>
              {title}
            </Typography>
          </Box>
          {showCloseButton && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'text.secondary',
              }}
            >
              <Close />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent
        dividers
        sx={{
          p: { xs: 2, sm: 3 },
          overflowY: 'auto',
          maxHeight: { xs: 'none', sm: '70vh' },
        }}
      >
        {children}
      </DialogContent>
      {actions && (
        <DialogActions
          sx={{
            px: { xs: 2, sm: 3 },
            py: 2,
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            gap: 1,
            '& > *': {
              width: { xs: '100%', sm: 'auto' },
              m: '0 !important',
            },
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  )
}

export const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'primary',
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="xs"
      actions={
        <>
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            {cancelText}
          </Button>
          <Button
            variant="contained"
            color={confirmColor}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmText}
          </Button>
        </>
      }
    >
      <Typography>{message}</Typography>
    </Modal>
  )
}

export default Modal
